// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"10":"Video-Video","46":"Geospatial-Geospatial","78":"Text-Text","80":"Demo-manifest","158":"Image-Image","522":"CSV-CSV","560":"VegaSpec-VegaSpec","581":"vendor-vega","686":"Demo-Demo","914":"Audio-Audio","990":"Html-Html"}[chunkId] || chunkId) + ".chunk.bundle.js";
};